export default function startDatesModal() {
    $(document).on('click', '.start-dates-button', function(e){
        e.preventDefault();

        $('#start-dates-modal').modal();
    });
}

